import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaRocket, FaUsers, FaLightbulb, FaArrowRight } from 'react-icons/fa';
import './QuemSomosPreview.css';

const QuemSomosPreview = () => {
  const navigate = useNavigate();

  const goToQuemSomos = () => {
    navigate('/quem-somos');
  };

  const features = [
    {
      icon: <FaRocket />,
      title: 'Agilidade',
      description: 'Entregas ágeis, sem perder eficiência'
    },
    {
      icon: <FaUsers />,
      title: 'Colaboração',
      description: 'Trabalho em equipe para entregar o melhor resultado'
    },
    {
      icon: <FaLightbulb />,
      title: 'Criatividade',
      description: 'Soluções criativas para desafios complexos'
    }
  ];

  return (
    <section className="section quem-somos-preview-section">
      <div className="container">
        <motion.div
          className="preview-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="preview-text">
            <h2 className="section-title">Sobre nós</h2>
            <p className="section-subtitle">Transformando ideias em realidade digital</p>
            
            <div className="preview-description">
              <p>
                A <strong>MicroCodie</strong> nasceu da vontade de criar soluções 
                que realmente fazem a diferença na vida das pessoas e das empresas. Procuramos ajudar
                empresas a evoluírem com agilidade, inovação e suporte contínuo.
              </p>
              <p>
                Nossa missão é simplificar a complexidade tecnológica, oferecendo soluções acessíveis, 
                eficientes e escaláveis. Trabalhamos para entregar 
                produtos que superam as expectativas e geram valor real para nossos clientes.
              </p>
            </div>

            <button 
              onClick={goToQuemSomos}
              className="btn btn-primary saiba-mais-btn"
            >
              Saiba mais sobre nós
              <FaArrowRight />
            </button>
          </div>

          <div className="preview-features">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="preview-feature"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default QuemSomosPreview; 